import { render, staticRenderFns } from "./MintalMesPrdSmeltingPelletFeedingList.vue?vue&type=template&id=b7671704&"
import script from "./MintalMesPrdSmeltingPelletFeedingList.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdSmeltingPelletFeedingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports